import { render, staticRenderFns } from "./snippletTabellaManuale.vue?vue&type=template&id=2d46962e&scoped=true"
import script from "./snippletTabellaManuale.vue?vue&type=script&lang=js"
export * from "./snippletTabellaManuale.vue?vue&type=script&lang=js"
import style0 from "./snippletTabellaManuale.vue?vue&type=style&index=0&id=2d46962e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d46962e",
  null
  
)

export default component.exports